import { render, staticRenderFns } from "./ShowDeletedItems.vue?vue&type=template&id=1e0614b0&"
import script from "./ShowDeletedItems.vue?vue&type=script&lang=js&"
export * from "./ShowDeletedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports